import { useQuery } from "@tanstack/react-query";
import {
  CompaniesControllerGetCompaniesBasics200Response,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_COMPANIES } from "../domain";

import { companiesApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

export const ACTION_GET_COMPANIES_BASICS = "GET_COMPANIES_BASICS";

type GetCompaniesBasicsProps = {
  companyName?: string;
  companyType?: number;
  search?: string;
  orderBy?: string;
  orderDirection?: string;
  pageNumber?: number;
  pageSize?: number;
};

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const getCompaniesBasics = async (
  props?: GetCompaniesBasicsProps,
): Promise<CompaniesControllerGetCompaniesBasics200Response | undefined> => {
  const response = await companiesApi.companiesControllerGetCompaniesBasics(
    props?.companyName,
    props?.companyType,
    props?.search,
    props?.orderBy,
    props?.orderDirection,
    props?.pageNumber,
    props?.pageSize,
  );

  return response.data;
};

export const useGetCompaniesBasics = (
  user: UserProfileDto | null,
  props?: GetCompaniesBasicsProps,
): {
  companiesBasics?: CompaniesControllerGetCompaniesBasics200Response;
  companiesBasicsEnabled: boolean;
  isPendingGetCompaniesBasics: boolean;
  isSuccessGetCompaniesBasics: boolean;
  refetchCompaniesBasics: () => void;
} => {
  const enabled = roleGuard(user, allowedRoles);

  const { data, isPending, isSuccess, refetch } = useQuery({
    queryKey: [DOMAIN_COMPANIES, ACTION_GET_COMPANIES_BASICS, props],
    queryFn: () => getCompaniesBasics(props),
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled,
  });

  return {
    companiesBasics: data,
    companiesBasicsEnabled: enabled,
    isPendingGetCompaniesBasics: isPending,
    isSuccessGetCompaniesBasics: isSuccess,
    refetchCompaniesBasics: refetch,
  };
};
